import { isGrpcRuntimeAvailable } from '../grpc/transport';

export type RuntimeMode = 'hostObject' | 'grpc' | 'mock';

export interface RuntimeCapabilities {
  mode: RuntimeMode;
  canConfigureMappings: boolean;
  canHighlightElements: boolean;
  canReconnect: boolean;
  canQuickFix: boolean;
  canExportReports: boolean;
}

export function getRuntimeCapabilities(): RuntimeCapabilities {
  // gRPC takes precedence over mock — when ?grpcPort= is in the URL,
  // the Revit plugin is running and we should use real data.
  if (isGrpcRuntimeAvailable()) {
    return {
      mode: 'grpc',
      canConfigureMappings: true,
      canHighlightElements: true,
      canReconnect: true,
      canQuickFix: true,
      canExportReports: true,
    };
  }

  return {
    mode: 'mock',
    canConfigureMappings: true,
    canHighlightElements: true,
    canReconnect: true,
    canQuickFix: true,
    canExportReports: true,
  };
}
